import { render, staticRenderFns } from "./ProductSideImage.vue?vue&type=template&id=249bd8ac&scoped=true&"
import script from "./ProductSideImage.vue?vue&type=script&lang=ts&"
export * from "./ProductSideImage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSideImage.vue?vue&type=style&index=0&id=249bd8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249bd8ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VFlex,VIcon})
